import { z } from "zod";
export function isProductParent(item) {
    if (!item) {
        return false;
    }
    return (typeof item === "object" &&
        "PK" in item &&
        typeof item.PK === "string" &&
        /^PRODUCT#/.test(item.PK) &&
        "type" in item &&
        typeof item.type === "string" &&
        Object.keys(ProductNames).includes(item.type));
}
export function isProduct(item) {
    if (!item) {
        return false;
    }
    return (typeof item === "object" &&
        "PK" in item &&
        typeof item.PK === "string" &&
        /^PRODUCT#/.test(item.PK) &&
        "type" in item &&
        typeof item.type === "string" &&
        Object.keys(ProductNames).includes(item.type));
}
export function isProductOption(item) {
    return (!!item &&
        typeof item === "object" &&
        "SK" in item &&
        typeof item.SK === "string" &&
        /OPTION#/.test(item.SK));
}
export const productTypesSchema = z.union([
    z.literal("AnnualSponsorship"),
    z.literal("CeremonyTicket"),
    z.literal("HumpdayGiveaway"),
    z.literal("MagazineAd"),
    z.literal("MagazineAdDeposit"),
    z.literal("MagazineArticle"),
    z.literal("Magazine"),
    z.literal("MagazineDeposit"),
    z.literal("Plaque"),
    z.literal("VotingStageSponsorship"),
    z.literal("VoterRewards"),
    z.literal("Upgrade"),
]);
// export const ProductNames: Record<ProductType, string> = {
//   AnnualSponsorship: "Annual Sponsorship",
//   CeremonyTicket: "Ceremony Ticket",
//   HumpdayGiveaway: "Humpday Giveaway",
//   VotingStageSponsorship: "Voting Stage Sponsorship",
//   VoterRewards: "Voter Rewards",
//   Magazine: "Magazine",
//   MagazineDeposit: "Magazine Deposit",
//   MagazineAd: "Magazine Ad",
//   MagazineAdDeposit: "Magazine Ad Deposit",
//   MagazineArticle: "Magazine Article",
//   Plaque: "Plaque",
//   Upgrade: "Upgrade",
// } as const;
export const ProductNames = {
    AnnualSponsorship: "Annual Sponsorship",
    CeremonyTicket: "Ceremony Ticket",
    HumpdayGiveaway: "Humpday Giveaway",
    VotingStageSponsorship: "Voting Stage Sponsorship",
    VoterRewards: "Voter Rewards",
    Magazine: "Magazine",
    MagazineDeposit: "Magazine Deposit",
    MagazineAd: "Magazine Ad",
    MagazineAdDeposit: "Magazine Ad Deposit",
    MagazineArticle: "Magazine Article",
    Plaque: "Plaque",
    Upgrade: "Upgrade",
};
export const ProductOptionNames = {
    AnnualSponsorship: {
        SilverSponsorship: "Silver Sponsorship",
        SilverComboSponsorship: "Silver Sponsorship",
        GoldSponsorship: "Gold Sponsorship",
        GoldComboSponsponship: "Gold Sponsorship",
        PlatinumSponsorship: "Platinum Sponsorship",
        PlatinumComboSponsorship: "Platinum Sponsorship",
    },
    CeremonyTicket: {
        GeneralCeremonyTicket: "General Ceremony Ticket",
        VIPCeremonyTicket: "VIP Ceremony Ticket",
    },
    HumpdayGiveaway: {
        HumpdayGiveawayBase: "Standard Humpday Giveaway",
    },
    Magazine: {
        PrintedMagazine: "Magazine",
    },
    MagazineDeposit: {
        MagazineDoubleDeposit: "Double Your Magazine Deposit",
    },
    MagazineAd: {
        QuarterPageAd: "Quarter Page Ad",
        HalfPageAd: "Half Page Ad",
        FullPageAd: "Full Page Ad",
    },
    MagazineAdDeposit: {
        DoubleDeposit: "Double Your Deposit",
    },
    MagazineArticle: {
        QuarterPageArticle: "Quarter Page Article",
        HalfPageArticle: "Half Page Article",
        FullPageArticle: "Full Page Article",
        SpotlightArticle: "Spotlight Article",
    },
    Plaque: {
        EngravedPlaque: "Engraved Plaque",
        PreviousYearPlaque: "Previous Year Plaque",
    },
    VotingStageSponsorship: {
        VotingStageSponsorshipBase: "Standard Voting Stage Sponsorship",
    },
    VoterRewards: {
        VoterRewardsBase: "Standard Voter Rewards",
    },
    Upgrade: {
        VIPUpgrade: "Upgrade tickets to V.I.P.",
    },
};
export const ProductAvailability = {
    Always: "Always",
    DateRange: "DateRange",
};
export const Selectables = {
    AwardYear: "Award Year",
    Category: "Category",
};
const bundledProductSchema = z.object({
    optionType: z.string(),
    quantity: z.number().int(),
    type: z.string(),
});
const upsellSchema = z.object({
    optionType: z.string().optional(),
    type: z.string(),
});
const comboDiscountSchema = z.object({
    amount: z.union([z.number(), z.string()]),
    type: productTypesSchema,
});
const sponsorDiscountSchema = z.object({
    sponsorshipPK: z.string(),
    amount: z.number(),
});
const ceremonyNightSchema = z.object({
    originalQuantityAvailable: z.number().int(),
    quantityAvailable: z.number().int(),
    newTotalQuantity: z.number().int().optional().default(0),
    quantitySold: z.number().int().default(0),
    soldOut: z.boolean().optional(),
});
const optionSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.literal("PRODUCTS"),
    GSI1_SK: z.string(),
    active: z.coerce.boolean(),
    adminPurchaseNotification: z.coerce.boolean().default(false),
    awardYear: z.number().int().optional(),
    bundledProducts: z.array(bundledProductSchema).default([]),
    comboDiscounts: z.array(comboDiscountSchema).default([]),
    customComponent: z.string().optional(),
    description: z.string(),
    htmlContent: z.string().optional(),
    id: z.string(),
    imageUrl: z.string().optional(),
    maxQuantity: z.number().int().optional(),
    maxQuantityReached: z.boolean().optional(),
    name: z.string(),
    newTotalQuantity: z.number().int().optional().default(0),
    nights: z.array(ceremonyNightSchema).default([]),
    originalQuantityAvailable: z.union([z.number().int(), z.null()]),
    price: z.number().int(),
    quantityAvailable: z.union([z.number().int(), z.null()]),
    quantityAvailableReached: z.boolean().optional(),
    quantitySold: z.number().int().default(0),
    quantityUnlimited: z.boolean(),
    selectables: z.record(z.boolean()).optional(),
    shippable: z.coerce.boolean(),
    slug: z.string(),
    soldOut: z.boolean().optional(),
    sponsorDiscounts: z.array(sponsorDiscountSchema).default([]),
    stripeProductId: z.string(),
    taxable: z.coerce.boolean(),
    type: z.string(),
    updatedAt: z.string().datetime().default(new Date().toISOString()),
    upgrade: z.object({
        productType: productTypesSchema,
        fromOptionType: z.string(),
        toOptionType: z.string(),
    }).optional(),
    upsells: z.array(upsellSchema).default([]),
});
export const productParentSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.literal("PRODUCTS"),
    GSI1_SK: z.string(),
    active: z.boolean(),
    adminPurchaseNotification: z.boolean(),
    archived: z.string().optional(),
    availability: z.union([z.literal("Always"), z.literal("DateRange")]),
    customComponent: z.string().optional(),
    datesAvailable: z.union([z.array(z.string()), z.null()]),
    description: z.string(),
    htmlContent: z.string().optional(),
    id: z.string(),
    maxQuantity: z.union([z.number().int(), z.null()]),
    maxQuantityReached: z.boolean().optional(),
    name: z.string(),
    options: z.array(optionSchema),
    slug: z.string().optional(),
    taxable: z.boolean().optional(),
    type: productTypesSchema,
    upsells: z.array(upsellSchema).default([]),
});
//# sourceMappingURL=products.js.map